<template>
    <div class="grid grid-cols-12 gap-5 p-5">
        <router-link :to="{ name: 'member-plan', params: { mid: dataList._id }, query:{prob: activeTab, code: data.code} }" class="col-span-12 md:col-span-6 lg:col-span-4" v-for="data in summary_problem" :key="data">
        <!-- <div class="col-span-12 md:col-span-6 lg:col-span-4" v-for="data in summary_problem" :key="data" @click="planClick(data)"> -->
            <div class="box rounded-md relative zoom-in shadow-lg bg-[#f2f2f2] h-full">
                <div class="header p-3 border-b-1 flex justify-between items-center">
                    <div class="pr-2">{{data.desc == "อื่นๆ" ? data.desc+' ('+data.name+')': data.desc}}</div>
                    <div v-if="getAllowActionByCurrRole('edit-problem-plan')">
                        <div class="t-tooltip flex justify-center items-center w-8 h-8" v-if="data.status == 3">
                            <span class="pause-icon" @click.prevent="activePlanStatus(data, 2)"></span>
                            <span class="t-tooltip-text">
                                ยกเลิกการยุติปัญหา
                            </span>
                        </div>
                        <div class="t-tooltip flex justify-center items-center w-8 h-8" v-else-if="data.status == 2">
                            <span class="play-icon" @click.prevent="activePlanStatus(data, 3)"></span>
                            <span class="t-tooltip-text">
                                ยุติปัญหา
                            </span>
                        </div>
                    </div>
                </div>
                <div class="font-medium text-center p-3 py-5 box-card">
                    <div class="text-xs p-1 text-white" :class="data.status > 0 ? 'bg-[#92d0a3]' : 'bg-[#d9d9d9]'">ทำแผนแล้ว</div>
                    <div class="text-xs p-1 ml-1 text-white" :class="data.status > 1 ? 'bg-[#68c483]' : 'bg-[#d9d9d9]'">ติดตามแล้ว</div>
                    <div class="text-xs p-1 ml-1 text-white" :class="data.status == 3 ? 'bg-[#05af50]' : 'bg-[#d9d9d9]'">ยุติปัญหา</div>
                </div>
            </div>
        <!-- </div> -->
        </router-link>
    </div>
</template>

<script setup>
import { computed } from "vue"
import Swal from "sweetalert2";
import { useStore } from "vuex";
import axios from "axios"
import { getAllowActionByCurrRole, getCurrentRole } from "@/utils/get-roles"

const swalCustom = Swal.mixin({
  customClass: {
    confirmButton: 'btn btn-primary m-1',
    cancelButton: 'btn btn-outline-secondary m-1'
  },
  buttonsStyling: false
})
const props = defineProps({
    dataList: Object,
    activeTab: String
})
const summary_problem = computed(() => {
  let result = []
  if(props.dataList.prob_summary){
    if(Object.keys(props.dataList.prob_summary)?.length > 0 && props.dataList.prob_summary[props.activeTab]?.length > 0){
        result =[...props.dataList.prob_summary[props.activeTab]]
    }
  }
  return result
})
const store = useStore()
const emits = defineEmits(["updateProbSummary"])

const activePlanStatus = (data, status) =>{
    let curr_dim = props.activeTab
    let tempProb = JSON.parse(JSON.stringify(props.dataList.prob_summary))
    let probIdx = tempProb[curr_dim].findIndex(x=>x.code == data.code)
    tempProb[curr_dim][probIdx].status = status
    let dialogText = ""
    if(status == 2){
        dialogText = "ยืนยันยกเลิกการยุติปัญหา"
    }
    else{
        dialogText = "ยืนยันการยุติปัญหา"
    }
    const token = store.getters["userAuth/getToken"];
    swalCustom.fire({
        html: `<div>${dialogText}</div><div>${data.desc == "อื่นๆ" ? data.desc+' ('+data.name+')' : data.desc}</div>`,
        icon:"info",
        showCancelButton: true,
        reverseButtons: true,
        confirmButtonText: 'ตกลง',
        cancelButtonText: 'ยกเลิก',
    }).then(async (result)=>{
        if(result.isConfirmed){
            const config = {
                url: `${process.env.VUE_APP_BASE_API}member/${props.dataList._id}`,
                method: "PUT",
                headers:{
                    Authorization: `Bearer ${token}`,
                    "Content-Type": `application/json; charset=utf-8`,
                },
                data:{
                    update:{
                        prob_summary: tempProb
                    }
                }
            }
            axios(config)
            .then(()=>{
                swalCustom.fire({
                text:"สำเร็จ",
                icon: 'success',
                timer: 3000,
                confirmButtonText: "ปิด",
                }).then(() => {
                    emits("updateProbSummary");
                });
            })
            .catch((error) => {
                swalCustom.fire({
                    text: "ทำรายการไม่สำเร็จ โปรดลองอีกครั้ง",
                    icon: "warning",
                    //timer: 3000, //timeOut for auto-close
                    confirmButtonText: "ปิด",
                });
                console.log(error);
            });
        }
    })
}
</script>

<style lang="scss">

.box-card{
    display: flex;
    flex-wrap: nowrap !important;
    column-gap: 3px;
    flex-direction: row;
    row-gap: 3px;
    justify-content: center;
}
.play-icon {
  background-image: url(@/assets/images/icon/play-alt-svg.svg);
  background-size: 100%;
  width: 100%;
  height: 100%;
  transition: all .2s ease-out;
  &:hover{
    transform: scale(1.2);
  }
}
.pause-icon {
  background-image: url(@/assets/images/icon/pause-svg.svg);
  background-size: 100%;
  width: 100%;
  height: 100%;
  transition: all .2s ease-out;
  &:hover{
    transform: scale(1.2);
  }
}

</style>